import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["fieldProps", "request", "params", "proFieldProps"];
import React from 'react';
import ProFormField from "../Field";

/**
 * 分段控制器
 *
 * @param
 */
import { jsx as _jsx } from "react/jsx-runtime";
var ProFormSegmented = function ProFormSegmented(_ref, ref) {
  var fieldProps = _ref.fieldProps,
    request = _ref.request,
    params = _ref.params,
    proFieldProps = _ref.proFieldProps,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsx(ProFormField, _objectSpread({
    valueType: "segmented",
    fieldProps: fieldProps,
    ref: ref,
    request: request,
    params: params,
    filedConfig: {
      customLightMode: true
    },
    proFieldProps: proFieldProps
  }, rest));
};
var WarpProFormSegmented = /*#__PURE__*/React.forwardRef(ProFormSegmented);
export default WarpProFormSegmented;